module.exports = "<div class=\"login\">\n    <div class=\"message\">\n        {{message}}\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/login/login.component.html
// module id = ./src/app/components/login/login.component.html
// module chunks = main